import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";

export class GlemtKodeordFormBuilder {
    public static opretForm(): UntypedFormGroup {
        const builder = new UntypedFormBuilder();
        return builder.group({
            nytKodeord: ["", [Validators.required, Validators.minLength(4), Validators.maxLength(24)]],
            gentagNytKodeord: ["", [Validators.required, this.erKodeordEns]]
        });
    }

    private static erKodeordEns(abstractControl: AbstractControl): { invalid: boolean } {
        if (!abstractControl.parent || !abstractControl) {
            return { invalid: true };
        }

        const kodeord = abstractControl.parent.get("nytKodeord");
        const gentagKodeord = abstractControl.parent.get("gentagNytKodeord");

        // En validator returnere ValidationErrors eller null
        if (kodeord && gentagKodeord && kodeord.value === gentagKodeord.value) {
            return null;
        }
        return { invalid: true };
    }
}
